import { FilterItem } from "@/types/filters";
import { RegionalFiltersData } from "@assets/mocks/filterData";
import useAuth from "@hooks/useAuth";
import { selectFavFilters, toggleFavorite } from "@redux/slices/favourite";
import { Star } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { FilterAtom } from "@/App";
import {useRecoilState } from "recoil";
import Radius from "../../../../assets/icons/triggerIcons/noun-event-7222663-1C1B2D.png";

const TriggerEvents = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const favFilters = useSelector(selectFavFilters);
  const { user } = useAuth();

  const handleToggleFav = (val: FilterItem, index: number) => {
    dispatch(
      toggleFavorite({
        title: val.title,
        description: val.description,
        path: val.path,
        index,
      })
    );
  };
  const [filter, setFilter] = useRecoilState(FilterAtom); 

  const isFav = (path: string): boolean => {
    const fav = favFilters.some((fav) => fav.path === path);
    return fav;
  };
  console.log(favFilters);
  return (
    <div className="w-2/3">
      <div className="flex gap-3">
        {/* {TriggerEventsData.slice(0, 3)?.map((val, index) => {
          return ( */}
        <div
 className={`bg-white flex justify-center items-center text-center px-4 flex-col h-52 rounded-lg w-1/3 cursor-pointer relative 
  ${filter.includes("Trigger Events") ? 'border-4' : ''}`} // Add border conditionally
style={{ borderColor: filter.includes("Trigger Events") ? '#1CB5AF' : 'transparent' }}          onClick={() =>
            navigate(`/targetMarkets/${user?.role}/?filter=triggerEventsData`)
          }
        >
          <img src="/assets/images/image 5.svg" alt="" />
          {/* <Star
                className={`absolute top-5 right-5 cursor-pointer ${
                  isFav(val.path) ? "fill-current text-yellow-500" : ""
                }`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleToggleFav(val, index + 3);
                }}
              /> */}

<img
                src={Radius}
                alt=""
                className="h-[75px]"
              />
          <h6 className="text-gray text-lg font-medium pt-2 pb-3">
            Trigger Events
          </h6>
          <p className="text-[#71717A] text-sm">
            Include or exclude specific companies
          </p>
        </div>
        {/* );
        })} */}
      </div>
    </div>
  );
};

export default TriggerEvents;
